import * as React from 'react'
import { BButton, BCol, BRow, BText } from '@prague-digi/ui-components'

import messages from '../../i18n'
import { SUPPORT_PHONE } from '../../constants/commonConstants'
import { intl, IntlInterface } from '../../hoc'
import phoneIcon from '../../assets/phoneRinging.svg'
import ProgressLine from '../ProgressLine/ProgressLine'
import styles from './StickyFooter.styles.scss'

interface Props {
  disabled: boolean
  goNext: Function
  goNextMsg: any
  readingProgress: number
}

export const StickyFooter: React.FC<Props & IntlInterface> = ({
  translate,
  disabled,
  readingProgress,
  goNext,
  goNextMsg,
}: Props & IntlInterface) => (
  <div className={styles.footer}>
    <BRow>
      <BCol>
        <ProgressLine
          max={1}
          message={messages.components.stickyFooter.progress}
          min={0}
          value={readingProgress}
        />
        <br />
        <b>
          {translate(messages.components.stickyFooter.info)}
          <img className={styles.phone} alt="" src={phoneIcon} />
          <BText component="span" type="info">
            {SUPPORT_PHONE}
          </BText>
        </b>
      </BCol>
      <BCol theme="col-md-auto mt-4 mt-md-0" xs={12}>
        <BButton
          color="primary"
          data-test-id="goNext"
          disabled={disabled}
          messages={{ message: translate(goNextMsg) }}
          onClick={goNext}
          theme="h-100 w-100"
          style={{ whiteSpace: 'normal' }}
        />
      </BCol>
    </BRow>
  </div>
)

export default intl(StickyFooter)
